module.exports = __webpack_public_path__ + "onboarding-pkg-extensions.7c98d423386b647a5816ce4a46443983.hashedasset.svg";